import { Grid, OutlinedInput } from '@mui/material'
import { forwardRef, useImperativeHandle, useState } from 'react'

export const DescriptionModal = forwardRef(function DescriptionModal_({ type }, ref) {
  const [description, setDescription] = useState('')
  useImperativeHandle(ref, () => {
    return {
      description
    }
  })

  return (
    <Grid container spacing={1} alignItems="center">
      <Grid item xs={12}>
        <OutlinedInput
          placeholder={`${type} description`}
          color="secondary"
          value={description}
          onChange={({ target: { value } }) => {
            setDescription(value)
          }}
          fullWidth
        />
      </Grid>
    </Grid>
  )
})
